<template>
  <div>
    <v-layout row v-for="data in chartColors" :key="data.label">
      <v-flex
        class="graph-color-list"
        v-if="chartLabels.find(e => e === data.label)"
      >
        <swatches
          v-model="data.color"
          :value="data.color"
          popover-to="left"
          shapes="squares"
          max-height="600"
          :trigger-style="triggerStyle"
          :wrapper-style="wrapperStyle"
          :colors="colors"
          :show-border="true"
          background-color="#000000"
          :swatch-style="swatchStyle"
          @input="changeColors($event, data.label)"
        ></swatches>
        <input
          class="b-checkbox"
          type="checkbox"
          :id="data.label"
          :value="data.label"
          v-model="selectedLabels"
          @click="changeLabels($event)"
          :checked="checkIfSelected(data.label)"
        />
        <label :for="data.label">{{ data.label | translate }}</label>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Swatches from "vue-swatches";
import * as chartOptions from "./../../common/ChartsOptions";
import {
  getIndexByLabel,
  getItemFromLocalStorage,
  setItemToLocalStorage
} from "./../../common/HelperFunctions";
export default {
  props: {
    //chart name
    chartName: {
      type: String,
      default: ""
    },
    //chart labels to show
    chartLabels: {
      type: Array,
      default: () => []
    },
    //chart colors to show
    chartColors: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      //slected labels for which data is plotted
      selectedLabels: getItemFromLocalStorage(
        "selectedLabels-" + this.chartName
      )
        ? getItemFromLocalStorage("selectedLabels-" + this.chartName)
        : [],

      swatchStyle: {
        width: "18px",
        height: "18px",
        borderRadius: "2px",
        float: "left",
        margin: "1px"
      },
      triggerStyle: {
        width: "14px",
        height: "14px",
        borderRadius: "2px",
        position: "relative",
        top: "2px"
      },
      wrapperStyle: {
        width: "160px !important",
        padding: "0"
      },
      colors: chartOptions.chartsColors
    };
  },
  components: {
    Swatches
  },
  methods: {
    initData() {
      this.chartColors.forEach(data => {
        // console.log('innnnnn: ', data.label, this.chartLabels.findIndex(e => e === data.label),  this.chartLabels[0]);
        if (!this.chartLabels.find(e => e === data.label)) {
          if (this.selectedLabels.indexOf(data.label) !== -1) {
            this.selectedLabels.splice(
              this.selectedLabels.indexOf(data.label),
              1
            );
            setItemToLocalStorage(
              "selectedLabels-" + this.chartName,
              this.selectedLabels
            );
          }
        }
      });
    },
    /*
     * on selecting or deselecting labels this method is
     * called to emit and to update chart accordingly
     */
    changeLabels(e) {
      if (e.target.checked) {
        this.selectedLabels.push(e.target.value);
      } else {
        this.selectedLabels.splice(
          this.selectedLabels.indexOf(e.target.value),
          1
        );
      }
      this.$emit("updateLabels", e);
      setItemToLocalStorage(
        "selectedLabels-" + this.chartName,
        this.selectedLabels
      );
    },
    /*
     * checks if a label is selected or not in order to
     * mark it checked or unchecked
     */
    checkIfSelected(label) {
      if (this.selectedLabels.indexOf(label) !== -1) return true;
      return false;
    },
    /*
     * this method is called when color of label is updated
     * to update color in local storage and chartColors array
     */
    changeColors(e, label) {
      let index = getIndexByLabel(this.chartColors, label);
      this.chartColors[index].color = e;
      setItemToLocalStorage("chartColors-" + this.chartName, this.chartColors);
      this.$emit("updateColors", e, label);
    }
  },
  watch: {
    chartLabels(oldVal, newVal) {
      this.initData();
    }
  }
};
</script>
<style>
.vue-swatches {
  display: inline-block;
}
.b-checkbox {
  position: relative;
  top: 1px;
  margin-left: 10px;
  margin-right: 3px;
}
.vue-swatches__trigger {
  border: 1px solid #000;
}
.graph-color-list {
  height: 20px;
  display: flex;
  align-items: center;
}
.graph-color-list label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vue-swatches__container {
  margin-right: 20px;
  margin-top: -20px;
  border-radius: 6px;
}
</style>
